import React from 'react';
import { UnderConstructionCone } from './graphic';
import { LinkButton } from '@/components/ui/LinkButton/LinkButton';
import { AppStoreLinks } from '../Footer/Footer';
import { StoreLinks } from '@/types/storeLinks';

const host = process.env.NEXT_PUBLIC_HOST_NAME;

export const UnderConstruction: React.FC<{
  url?: string;
  label?: string;
  appLinks?: StoreLinks;
}> = ({ url, label, appLinks }) => {
  return (
    <section>
      <div className="tc-container flex flex-col-reverse items-center justify-between p-6 md:flex-row md:py-12">
        <div className="w-full space-y-5 md:w-1/2">
          <h2>Our web account area is currently under construction</h2>
          <p className="font-semibold">
            But don’t worry, you can still use our guest journey or your mobile app to get covered!
          </p>
          <p>
            Getting a temporary car insurance quote is super-quick. It takes under 2 minutes online or with a few taps
            in the Tempcover app.
          </p>
          <div className="space-y-2 md:space-y-0 md:space-x-3">
            <div className="md:hidden">
              <p className="text-dark-400 text-[18px] font-bold">Get the app</p>
              <div className="flex gap-2">
                {appLinks?.value?.data.appStoreLink && appLinks?.value?.data.playStoreLink && (
                  <AppStoreLinks
                    appStore={appLinks.value.data.appStoreLink}
                    playStore={appLinks.value.data.playStoreLink}
                  />
                )}
              </div>
            </div>
            {url && label && (
              <LinkButton
                label={label}
                link={`${host}${url}`}
                variant="primary"
                size="smallPadded"
                className="w-full md:w-auto"
              />
            )}
          </div>
        </div>
        <div className="mb-6 flex w-full justify-center md:mb-0 md:w-1/2">
          <div className="mx-auto max-w-[144px] md:max-w-[315px]">
            <UnderConstructionCone />
          </div>
        </div>
      </div>
    </section>
  );
};
